import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToPlainText'
})
export class HtmlToPlainText implements PipeTransform {
    transform(text: string, limit: number): string {
        if (text) {
            let plainText = String(text).replace(/<[^>]+>/gm, '');
            plainText = this.htmlDecode(plainText);
            const length = plainText.length;
            const suffix = '...';

            return plainText.length > limit ? plainText.substr(0, limit - 1) + suffix : plainText;
        } else {
            return text;
        }
    }

    htmlDecode(input) {
        const e = document.createElement('textarea');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/pipes/htmlToPlaintext.pipe.ts